import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-test-id"]
const _hoisted_2 = {
  key: 0,
  class: "max-w-full lg:max-w-[936px] text-racq-dark-grey text-base-bold pb-3"
}
const _hoisted_3 = { class: "hidden md:flex flex-row items-stretch rounded-lg w-full" }
const _hoisted_4 = {
  key: 0,
  class: "text-m-bold text-racq-dark-grey pb-2"
}
const _hoisted_5 = {
  key: 1,
  class: "text-lg-bold text-racq-dark-grey pb-1"
}
const _hoisted_6 = {
  key: 2,
  class: "text-m text-racq-med-grey"
}
const _hoisted_7 = {
  key: 3,
  class: "flex flex-wrap mt-4 flex-start gap-4"
}
const _hoisted_8 = {
  key: 4,
  class: "flex mt-4"
}
const _hoisted_9 = { class: "w-8 h-8 border-[1.5px] border-racq-light-blue-grey rounded-[40px] inline-flex justify-center items-center" }
const _hoisted_10 = { class: "w-2 h-5" }
const _hoisted_11 = {
  key: 0,
  class: "w-1/2 flex"
}
const _hoisted_12 = { class: "md:hidden flex flex-col rounded-lg" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "px-4 py-5" }
const _hoisted_15 = {
  key: 2,
  class: "flex items-center gap-2"
}
const _hoisted_16 = {
  key: 1,
  class: "flex mt-4"
}
const _hoisted_17 = { class: "w-8 h-8 border-[1.5px] border-racq-light-blue-grey rounded-[40px] inline-flex justify-center items-center" }
const _hoisted_18 = { class: "w-2 h-5" }
const _hoisted_19 = ["data-test-id"]
const _hoisted_20 = { class: "flex flex-col gap-4" }
const _hoisted_21 = {
  key: 0,
  class: "max-w-full lg:max-w-[936px] w-full lg:w-[936px] text-racq-dark-grey text-base-bold"
}
const _hoisted_22 = { class: "flex flex-col md:flex-row md:flex-wrap gap-4 w-full" }
const _hoisted_23 = ["data-test-id"]

import { computed } from 'vue';
import { RichText, Link, ComponentFields, Image, ComponentRendering } from '@sitecore-jss/sitecore-jss-vue';
import { BackgroundColours } from '@/interfaces/forms/background-colour.interface';
import { IPromoCardImageItem } from '@/interfaces/entities/promo-card-image.interface';
import Tag from '@/components/Tag/Tag.vue';
import { TagBgColour, TagSize, TagTypes } from '@/enums/tag-enums';
import BaseIcon from '@/components/BaseIcon/BaseIcon.vue';
import PromoCardImageContent from '@/components/PromoCardImage/PromoCardImageContent.vue';
import { usePageStore } from '@/store';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'PromoCardImage',
  props: {
    fields: {},
    rendering: {}
  },
  setup(__props: any) {

const props = __props;

const outerClass = props.rendering?.params?.Styles;
const inlineStyle = props.rendering?.params?.inlineStyle;
const promoCardImages = computed(() => props.fields.items as IPromoCardImageItem[]);
const firstPromoCardImage = computed(() => promoCardImages.value[0] as IPromoCardImageItem);
const renderChevronSingle = computed(
  () => firstPromoCardImage.value.fields.isChevron.value && firstPromoCardImage.value.fields.chevronUrl
);

const dataTestId = usePageStore().dataTestId(props.rendering ?? firstPromoCardImage.value);

function isValidPrimaryButton(promoCardImage: IPromoCardImageItem) {
  if (promoCardImage.fields.primaryButton?.value.text && promoCardImage.fields.primaryButton) {
    return true;
  }
  return false;
}

function isValidSecondaryButton(promoCardImage: IPromoCardImageItem) {
  if (promoCardImage.fields.secondaryButton?.value.text && promoCardImage.fields.secondaryButton) {
    return true;
  }
  return false;
}

function getMaxImageWidthClasses() {
  const promoCards = props.fields.items as IPromoCardImageItem[];
  if (promoCards.length === 1) {
    // return lg / default
    return '';
  } else if (promoCards.length === 2) {
    // return md
    return 'w-[300px] md:w-[340px]';
  } else {
    // return sm
    return 'md:w-[288px]';
  }
}

function getBackgroundColourClass(backgroundColour: any) {
  if (!backgroundColour) {
    return '';
  }
  switch (backgroundColour.value) {
    case BackgroundColours.WHITE:
      return 'bg-racq-true-white';
    case BackgroundColours.LIGHTGREY:
      return 'bg-racq-neutral-grey';
    case BackgroundColours.GREY:
      return 'bg-racq-anti-flash-white';
    default:
      return '';
  }
}

return (_ctx: any,_cache: any) => {
  return (promoCardImages.value.length === 1)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-test-id": _unref(dataTestId),
        class: _normalizeClass(_unref(outerClass)),
        style: _normalizeStyle(_unref(inlineStyle))
      }, [
        (_ctx.fields.heading?.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(RichText), {
                field: _ctx.fields.heading
              }, null, 8, ["field"])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_resolveDynamicComponent(renderChevronSingle.value ? 'a' : 'div'), {
          href: renderChevronSingle.value ? firstPromoCardImage.value.fields.chevronUrl?.value.href : undefined,
          target: renderChevronSingle.value ? firstPromoCardImage.value.fields.chevronUrl?.value.target : undefined,
          title: renderChevronSingle.value ? firstPromoCardImage.value.fields.chevronUrl?.value.title : undefined,
          class: _normalizeClass([
        'promo-card-image rounded-lg flex-col flex justify-start items-start max-w-full lg:max-w-[936px]',
        {
          'border-pale-blue border-[1.5px] shadow-md': firstPromoCardImage.value.fields.showBorder.value,
          'no-underline': renderChevronSingle.value,
        },
        getBackgroundColourClass(firstPromoCardImage.value.fields.backgroundColour),
      ])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass([
            'flex flex-col justify-center py-6 px-8',
            {
              'w-1/2': firstPromoCardImage.value.fields.image.value?.src,
              'w-full': !firstPromoCardImage.value.fields.image.value?.src,
            },
          ])
              }, [
                (firstPromoCardImage.value.fields.tag.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (!firstPromoCardImage.value.fields.tagIsText.value)
                        ? (_openBlock(), _createBlock(Tag, {
                            key: 0,
                            tagSize: _unref(TagSize).xs,
                            tagBgColour: _unref(TagBgColour).infoBlue,
                            tagText: firstPromoCardImage.value.fields.tag.value,
                            tagType: _unref(TagTypes).star
                          }, null, 8, ["tagSize", "tagBgColour", "tagText", "tagType"]))
                        : _createCommentVNode("", true),
                      (firstPromoCardImage.value.fields.tagIsText.value)
                        ? (_openBlock(), _createBlock(_unref(RichText), {
                            key: 1,
                            field: firstPromoCardImage.value.fields.tag
                          }, null, 8, ["field"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (firstPromoCardImage.value.fields.title.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_unref(RichText), {
                        "data-test-id": "promoTitle",
                        field: firstPromoCardImage.value.fields.title
                      }, null, 8, ["field"])
                    ]))
                  : _createCommentVNode("", true),
                (firstPromoCardImage.value.fields.description.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_unref(RichText), {
                        "data-test-id": "promoDescription",
                        field: firstPromoCardImage.value.fields.description
                      }, null, 8, ["field"])
                    ]))
                  : _createCommentVNode("", true),
                (
              !firstPromoCardImage.value.fields.isChevron.value &&
              (isValidPrimaryButton(firstPromoCardImage.value) || isValidSecondaryButton(firstPromoCardImage.value))
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (isValidPrimaryButton(firstPromoCardImage.value))
                        ? (_openBlock(), _createBlock(_unref(Link), {
                            key: 0,
                            field: firstPromoCardImage.value.fields.primaryButton,
                            class: _normalizeClass(`flex px-3 py-1.5 justify-center items-center self-stretch text-base btn btn-sm ${firstPromoCardImage.value.fields.primaryButton?.value.class}`),
                            "aria-label": firstPromoCardImage.value.fields.primaryButton?.value.text
                          }, null, 8, ["field", "class", "aria-label"]))
                        : _createCommentVNode("", true),
                      (isValidSecondaryButton(firstPromoCardImage.value))
                        ? (_openBlock(), _createBlock(_unref(Link), {
                            key: 1,
                            field: firstPromoCardImage.value.fields.secondaryButton,
                            class: _normalizeClass(`flex px-3 py-1.5 justify-center items-center self-stretch text-base btn btn-sm ${firstPromoCardImage.value.fields.secondaryButton?.value.class}`),
                            "aria-label": firstPromoCardImage.value.fields.secondaryButton?.value.text
                          }, null, 8, ["field", "class", "aria-label"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (renderChevronSingle.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(BaseIcon, {
                            iconClass: "bg-icon-chevron",
                            class: "!w-4 !h-4"
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              (firstPromoCardImage.value.fields.image?.value?.src)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_unref(Image), {
                      media: firstPromoCardImage.value.fields.image,
                      class: "w-full max-w-full min-h-64 h-full object-cover rounded-r-lg"
                    }, null, 8, ["media"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (firstPromoCardImage.value.fields.image)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_unref(Image), {
                      media: firstPromoCardImage.value.fields.image,
                      class: "w-full max-w-full lg:max-w-[430px] h-auto lg:h-full object-cover rounded-t-lg"
                    }, null, 8, ["media"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                (firstPromoCardImage.value.fields.tag)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass([
                'text-m-bold text-racq-dark-grey pb-2',
                { 'text-center': !firstPromoCardImage.value.fields.showBorder },
              ])
                    }, [
                      (!firstPromoCardImage.value.fields.tagIsText)
                        ? (_openBlock(), _createBlock(Tag, {
                            key: 0,
                            tagSize: _unref(TagSize).xs,
                            tagBgColour: _unref(TagBgColour).infoBlue,
                            tagText: firstPromoCardImage.value.fields.tag.value,
                            tagType: _unref(TagTypes).star
                          }, null, 8, ["tagSize", "tagBgColour", "tagText", "tagType"]))
                        : _createCommentVNode("", true),
                      (firstPromoCardImage.value.fields.tagIsText.value)
                        ? (_openBlock(), _createBlock(_unref(RichText), {
                            key: 1,
                            field: firstPromoCardImage.value.fields.tag
                          }, null, 8, ["field"]))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                (firstPromoCardImage.value.fields.title)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass([
                'text-lg-bold text-racq-dark-grey pb-1',
                { 'text-center': !firstPromoCardImage.value.fields.showBorder },
              ])
                    }, [
                      _createVNode(_unref(RichText), {
                        field: firstPromoCardImage.value.fields.title
                      }, null, 8, ["field"])
                    ], 2))
                  : _createCommentVNode("", true),
                (firstPromoCardImage.value.fields.description || renderChevronSingle.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (firstPromoCardImage.value.fields.description)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(['text-m text-racq-med-grey', { 'text-center': !firstPromoCardImage.value.fields.showBorder }])
                          }, [
                            _createVNode(_unref(RichText), {
                              field: firstPromoCardImage.value.fields.description
                            }, null, 8, ["field"])
                          ], 2))
                        : _createCommentVNode("", true),
                      (firstPromoCardImage.value.fields.isChevron.value && firstPromoCardImage.value.fields.chevronUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_unref(Link), {
                              field: firstPromoCardImage.value.fields.chevronUrl
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("div", _hoisted_18, [
                                    _createVNode(BaseIcon, {
                                      iconClass: "bg-icon-chevron",
                                      class: "!w-4 !h-4"
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["field"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (
              !firstPromoCardImage.value.fields.isChevron.value &&
              (isValidPrimaryButton(firstPromoCardImage.value) || isValidSecondaryButton(firstPromoCardImage.value))
            )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: _normalizeClass(['flex mt-4 flex-start gap-4', { 'justify-center': !firstPromoCardImage.value.fields.showBorder }])
                    }, [
                      (isValidPrimaryButton(firstPromoCardImage.value))
                        ? (_openBlock(), _createBlock(_unref(Link), {
                            key: 0,
                            field: firstPromoCardImage.value.fields.primaryButton,
                            class: _normalizeClass(`flex px-3 py-1.5 justify-center items-center self-stretch text-base btn btn-sm ${firstPromoCardImage.value.fields.primaryButton?.value.class}`),
                            "aria-label": firstPromoCardImage.value.fields.primaryButton?.value.text
                          }, null, 8, ["field", "class", "aria-label"]))
                        : _createCommentVNode("", true),
                      (isValidSecondaryButton(firstPromoCardImage.value))
                        ? (_openBlock(), _createBlock(_unref(Link), {
                            key: 1,
                            field: firstPromoCardImage.value.fields.secondaryButton,
                            class: _normalizeClass(`flex px-3 py-1.5 justify-center items-center self-stretch text-base btn btn-sm ${firstPromoCardImage.value.fields.secondaryButton?.value.class}`),
                            "aria-label": firstPromoCardImage.value.fields.secondaryButton?.value.text
                          }, null, 8, ["field", "class", "aria-label"]))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["href", "target", "title", "class"]))
      ], 14, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        "data-test-id": _unref(dataTestId)
      }, [
        _createElementVNode("div", _hoisted_20, [
          (_ctx.fields.heading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_unref(RichText), {
                  field: _ctx.fields.heading
                }, null, 8, ["field"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promoCardImages.value, (promoCardImage, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                "data-test-id": promoCardImage.fields.dataTestId?.value || _unref(dataTestId) + '_' + index
              }, [
                (promoCardImage.fields.isChevron.value && promoCardImage.fields.chevronUrl)
                  ? (_openBlock(), _createBlock(_unref(Link), {
                      key: 0,
                      field: promoCardImage.fields.chevronUrl,
                      class: "group block no-underline active:no-underline shadow-md hover:shadow-xl rounded-lg active:rounded-lg active:!shadow-none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(PromoCardImageContent, {
                          promoCardImage: promoCardImage,
                          isWrappedInLink: true,
                          tagSize: _unref(TagSize),
                          tagBgColour: _unref(TagBgColour),
                          tagTypes: _unref(TagTypes),
                          getMaxImageWidthClasses: getMaxImageWidthClasses,
                          getBackgroundColourClass: getBackgroundColourClass,
                          isValidPrimaryButton: isValidPrimaryButton,
                          isValidSecondaryButton: isValidSecondaryButton
                        }, null, 8, ["promoCardImage", "tagSize", "tagBgColour", "tagTypes"])
                      ]),
                      _: 2
                    }, 1032, ["field"]))
                  : (_openBlock(), _createBlock(PromoCardImageContent, {
                      key: 1,
                      class: _normalizeClass({
                'shadow-md': promoCardImage.fields.showBorder,
                'hover:shadow-lg': promoCardImage.fields.showBorder,
              }),
                      promoCardImage: promoCardImage,
                      isWrappedInLink: false,
                      tagSize: _unref(TagSize),
                      tagBgColour: _unref(TagBgColour),
                      tagTypes: _unref(TagTypes),
                      getMaxImageWidthClasses: getMaxImageWidthClasses,
                      getBackgroundColourClass: getBackgroundColourClass,
                      isValidPrimaryButton: isValidPrimaryButton,
                      isValidSecondaryButton: isValidSecondaryButton
                    }, null, 8, ["class", "promoCardImage", "tagSize", "tagBgColour", "tagTypes"]))
              ], 8, _hoisted_23))
            }), 128))
          ])
        ])
      ], 8, _hoisted_19))
}
}

})